import RegistreConfig from './_config/registres.routes';
import RegistresRoutes from './_config/registres.config';
import RegistresLegacyService from './services/registres-legacy.service';

import RegistresLegacyComponent from './components/registres';
import RepComponent from './components/rep';
import RndtsApiCallbackComponent from './components/rndts-api-callback';

import GridTexsEntrantComponent from './components/registres/components/grid-texs-entrant/';
import GridTexsSortantComponent from './components/registres/components/grid-texs-sortant/';
import GridDdEntrantComponent from './components/registres/components/grid-dd-entrant/';
import GridDdSortantComponent from './components/registres/components/grid-dd-sortant/';

const moduleName = 'app.massia.gestion.registre.eco.organismes';

angular
	.module(moduleName, [])
	.config(RegistreConfig)
	.config(RegistresRoutes)
	.service('registresLegacyService', RegistresLegacyService)
	.component('registresLegacy', RegistresLegacyComponent)
	.component('repLegacy', RepComponent)
	.component('gridTexsEntrant', GridTexsEntrantComponent)
	.component('gridTexsSortant', GridTexsSortantComponent)
	.component('gridDdEntrant', GridDdEntrantComponent)
	.component('gridDdSortant', GridDdSortantComponent)
	.component('rndtsApiCallback', RndtsApiCallbackComponent);

export default moduleName;
